export type spaceTokenNumberValue =
    | "0"
    | "025"
    | "050"
    | "075"
    | "100"
    | "150"
    | "200"
    | "250"
    | "300"
    | "400"
    | "500"
    | "600"
    | "800"
    | "1000";

export const spaceTokenValues: Record<string, spaceTokenNumberValue> = {
    "space.0": "0",
    "space.025": "025",
    "space.050": "050",
    "space.075": "075",
    "space.100": "100",
    "space.150": "150",
    "space.200": "200",
    "space.250": "250",
    "space.300": "300",
    "space.400": "400",
    "space.500": "500",
    "space.600": "600",
    "space.800": "800",
    "space.1000": "1000"
};

export type UniformEnvironment = "preview" | "staging" | "production";

export const isUniformEnvironment = (
    env: string
): env is UniformEnvironment => {
    return ["preview", "staging", "production"].includes(env);
};

export const getUniformEnvironment = (
    urlSearch: string
): UniformEnvironment => {
    let uniformEnvironment = process.env["CLIENT_LIBRARY_ENV"] ?? "";

    // Handle empty or invalid URL search params (e.g., during SSR)
    let searchParams: URLSearchParams;
    try {
        searchParams = new URLSearchParams(new URL(urlSearch).search);
    } catch {
        searchParams = new URLSearchParams();
    }

    if (
        searchParams.get("wacae-preview") &&
        uniformEnvironment !== "production"
    ) {
        return "preview";
    }

    if (uniformEnvironment === "local") {
        return "staging";
    }

    if (!isUniformEnvironment(uniformEnvironment)) {
        uniformEnvironment = "preview";
    }

    return uniformEnvironment as UniformEnvironment;
};
